import React, { FC, ReactNode } from 'react';

import { BaseStyleEnums, ReactTable } from '@nhl/nhl-breakaway-ui';
import { ColumnDef } from '@tanstack/react-table';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';

import { SeasonStats, SeasonStatsGoalie } from '../../../types';

import { FeaturedStatsTableContainer, StatsBarBottom, StatsBarLeftColumn, StatsBarTop } from './styles';

type StatsBarProps = {
    seasonStats: SeasonStats | SeasonStatsGoalie;
    careerStats: SeasonStats | SeasonStatsGoalie;
    seasonStatsLabel: ReactNode;
    careerStatsLabel: ReactNode;
    columns: Array<ColumnDef<SeasonStats | SeasonStatsGoalie>>;
    id: string;
};

export const FeaturedStatsBars: FC<StatsBarProps> = ({
    seasonStats,
    careerStats,
    seasonStatsLabel,
    careerStatsLabel,
    columns,
    id,
}) => {
    const screenSize = useSizeWithThrottle();

    const isSmall = screenSize.width <= BaseStyleEnums.ScreenWidthBreakpoints.medium;

    return isSmall ? (
        <>
            <div id={`${id}-featured-season-stats-container`}>
                <StatsBarLeftColumn id={`${id}-featured-season-stats-label`}>{seasonStatsLabel}</StatsBarLeftColumn>
                <StatsBarTop>
                    <FeaturedStatsTableContainer>
                        <ReactTable data={[seasonStats]} columns={columns} tableId={`${id}-featured-season-stats`} />
                    </FeaturedStatsTableContainer>
                </StatsBarTop>
            </div>

            <div id={`${id}-featured-career-stats-container`}>
                <StatsBarLeftColumn id={`${id}-featured-career-stats-label`}>{careerStatsLabel}</StatsBarLeftColumn>
                <StatsBarBottom>
                    <FeaturedStatsTableContainer>
                        <ReactTable data={[careerStats]} columns={columns} tableId={`${id}-featured-career-stats`} />
                    </FeaturedStatsTableContainer>
                </StatsBarBottom>
            </div>
        </>
    ) : (
        <>
            <StatsBarTop id={`${id}-featured-season-stats-container`}>
                <StatsBarLeftColumn id={`${id}-featured-season-stats-label`}>{seasonStatsLabel}</StatsBarLeftColumn>
                <FeaturedStatsTableContainer>
                    <ReactTable data={[seasonStats]} columns={columns} tableId={`${id}-featured-season-stats`} />
                </FeaturedStatsTableContainer>
            </StatsBarTop>

            <StatsBarBottom id={`${id}-featured-career-stats-container`}>
                <StatsBarLeftColumn id={`${id}-featured-career-stats-label`}>{careerStatsLabel}</StatsBarLeftColumn>
                <FeaturedStatsTableContainer>
                    <ReactTable data={[careerStats]} columns={columns} tableId={`${id}-featured-career-stats`} />
                </FeaturedStatsTableContainer>
            </StatsBarBottom>
        </>
    );
};
